export const config = {
    Authorization: localStorage.getItem("token")
}